module.exports = __webpack_public_path__ + "img/subscription-background.84df3cd5.svg";